var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProtected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M21.547 3.88621L12.3595 0.071666C12.1293 -0.0238652 11.8706 -0.0239121 11.6405 0.071666L2.45302 3.88621C2.10309 4.03153 1.875 4.37315 1.875 4.75204V9.38915C1.875 15.7741 5.73417 21.5176 11.6457 23.9305C11.8728 24.0232 12.1272 24.0232 12.3543 23.9305C18.2657 21.5176 22.125 15.7742 22.125 9.38915V4.75204C22.125 4.37315 21.897 4.03153 21.547 3.88621ZM20.25 9.38915C20.25 14.817 17.0625 19.8138 12 22.0442C7.07278 19.8734 3.75 14.9641 3.75 9.38915V5.37792L12 1.95257L20.25 5.37792V9.38915ZM10.9638 12.5492L14.9933 8.51967C15.3594 8.15357 15.953 8.15353 16.3192 8.51967C16.6853 8.88581 16.6852 9.47939 16.3191 9.84548L11.6267 14.5379C11.2605 14.9041 10.6669 14.9039 10.3009 14.5379L7.68084 11.9179C7.3147 11.5517 7.3147 10.9582 7.68084 10.5921C8.04698 10.226 8.64056 10.2259 9.00666 10.5921L10.9638 12.5492Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtected);
export default __webpack_public_path__ + "static/media/protected.9a62d2a356eea1812d1ca339dbba7794.svg";
export { ForwardRef as ReactComponent };